import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderInfoItemWrapperComponent = _resolveComponent("OrderInfoItemWrapperComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-1',
        "translate-key": 'pickup_and_return'
      }, {
        "icon-item": _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            src: "/assets/images/Framelocation-icon.png",
            alt: "location"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.orderData.destination.raw.name) + ", " + _toDisplayString(_ctx.orderData.destination.raw.formatted_address), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-2',
        "translate-key": 'pick_up'
      }, {
        "icon-item": _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            src: "/assets/images/Framecalendar-icon.png",
            alt: "pickup-date-time"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.dateHelpers.dateToDisplay(_ctx.orderData.pickupDate) + ' ' + _ctx.orderData.pickupTime.replace(/\s/g, '')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-3',
        "translate-key": 'passengers'
      }, {
        "icon-item": _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("img", {
            src: "/assets/images/Framepeople-icon.png",
            alt: "people-count"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.orderData.passengerCount), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_OrderInfoItemWrapperComponent, {
        "data-class-name": '__data-4',
        "translate-key": 'return'
      }, {
        "icon-item": _withCtx(() => _cache[3] || (_cache[3] = [
          _createElementVNode("img", {
            src: "/assets/images/Framecalendar-icon.png",
            alt: "end-date-time"
          }, null, -1)
        ])),
        "order-info": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.dateHelpers.dateToDisplay(_ctx.orderData.endDate) + ' ' + _ctx.orderData.endTime.replace(/\s/g, '')), 1)
        ]),
        _: 1
      })
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-sm-12 col-md-12 col-lg-11 hr-line" }, null, -1))
  ], 64))
}